import axios from "axios";

export const loadAllEnquiriesAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=${payload.pageSize}&admins=[${
        payload.salesman ?? ""
      }]&siteId=${
        payload?.appliedFilters?.siteId ?? ""
      }&dataLevel=1&countries=[${payload.selectedCountries}]&step=[${
        payload?.appliedFilters?.status ?? payload.statusFilters
      }]&page=${payload.currentPage}&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&status=${payload.status}&orderColumn=${
        payload.sort ? payload.sort.column : "id"
      }&search=${payload.search ?? ""}&dependancies=${
        payload?.appliedFilters?.dependancies
      }`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleEnquiryAPI = (payload) => {
  return axios
    .get(`/enquiries/${payload.enquiryId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
